"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "33", height: "33", viewBox: "0 0 33 33", className: "Icon element-line", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement("path", { d: "M27.462 6.953L1.707 32.707.293 31.293 26.046 5.54 24 3.5 33 0l-3.343 9.142-2.195-2.19z", fill: "#777", fillRule: "evenodd" })
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/element-line.js
// module id = 1797
// module chunks = 0